/*
 * Copyright (c) 2021. World Wide Generation Ltd
 */

import { frameworks } from '@g17eco/core';
import { ToolbarIconProps } from './ToolbarIcon';
import UniversalTrackerClassInterface from '../../../../model/UniversalTrackerClassInterface';

interface FrameworksButton {
  utr: UniversalTrackerClassInterface;
}

export const getFrameworkButtons = (props: FrameworksButton) => {
  const { utr } = props;

  const items: ToolbarIconProps[] = [];

  Object.keys(frameworks).forEach(frameworkCode => {
    const framework = frameworks[frameworkCode];
    if (framework.subgroups) {
      framework.subgroups.forEach(f => {
        if (utr.hasTag(frameworkCode, f.code)) {
          items.push({
            src: f.src,
            alt: f.shortName,
            tooltip: f.tooltip ?? f.name,
          });
        }
      })
    }
  });
  return items;
}
